import React, { useState, useEffect } from 'react';
import { View, ScrollView } from 'react-native';

import PropTypes from 'prop-types';

import { withAsyncAction } from '@vfgroup-oneplatform/foundation/Components/SpinnerOverlay';
import { LightThemeColors, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import DeleteCard from '../../Components/DeleteCard';
import PaymentError from '../../Components/PaymentError';
import {
  cardNumberFormatter,
  cvvFormater,
  nameOnCardFormatter,
  expirationDataFormatter,
} from '../../Utils/textFormatters';
import styles from '../AddPayment/AddPayment.styles';
import ScanCard from '../AddPayment/Components/ScanCard';
import AddPaymentForm from '../AddPaymentCard';

const closePaymentErrorModal = setIsPaymentErrorModalVisible => {
  setIsPaymentErrorModalVisible(false);
};
const closeDeleteCardModal = setIsVisible => {
  setIsVisible(false);
};

const handleEditPaymentFailed = (error, setPaymentErrorData, setIsPaymentErrorModalVisible) => {
  setTimeout(() => {
    setPaymentErrorData(error);
    setIsPaymentErrorModalVisible(true);
  }, 500);
};
const handlePressSaveCard = (
  onAsyncActionPressed,
  onPressSaveCard,
  cardDataParam,
  onEditPaymentSuccess,
  setPaymentErrorData,
  setIsPaymentErrorModalVisible,
  setCurrentCardData,
) => {
  setPaymentErrorData({});
  onAsyncActionPressed(
    async () => onPressSaveCard(cardDataParam),
    onEditPaymentSuccess,
    error => handleEditPaymentFailed(error, setPaymentErrorData, setIsPaymentErrorModalVisible),
  );
  setCurrentCardData(cardDataParam);
};
const handlePressDeleteCard = (
  onAsyncActionPressed,
  onPressDeleteCard,
  onEditPaymentSuccess,
  setIsVisible,
  setPaymentErrorData,
  setIsPaymentErrorModalVisible,
) => {
  setIsVisible(false);
  onAsyncActionPressed(
    async () => onPressDeleteCard(),
    onEditPaymentSuccess,
    handleEditPaymentFailed,
  );
};

const formatCardData = (cardDataParam, formatters) => {
  const formattedCardData = { ...cardDataParam };
  for (const fieldName in cardDataParam) {
    const fieldValue = cardDataParam[fieldName];
    if (formatters[fieldName]) {
      formattedCardData[fieldName] = formatters[fieldName](fieldValue);
    }
  }
  return formattedCardData;
};
const _getCardData = async (getCardData, setCardData, setCardDataLoading) => {
  const formatters = {
    cardNo: cardNumberFormatter,
    nameOnCard: nameOnCardFormatter,
    expirationData: expirationDataFormatter,
    cvvNo: cvvFormater,
  };
  try {
    const cardDataResponse = await getCardData();
    const formattedCardData = formatCardData(cardDataResponse, formatters);
    setCardData(formattedCardData);
  } catch (error) {
    // err handler
  } finally {
    setCardDataLoading(false);
  }
};
const EditPayment = ({
  onEditPaymentSuccess,
  onAsyncActionPressed,
  onPressSaveCard,
  getCardData,
  hideScanCard,
  withTray,
  title,
  onPressErrorAction,
  onPressDeleteCard,
  images,
  ...props
}) => {
  const [cardData, setCardData] = useState({});
  const [isDeleteCardModalVisible, setIsVisible] = useState(false);
  const [isCardDataLoading, setCardDataLoading] = useState(true);
  const [paymentErrorData, setPaymentErrorData] = useState({});
  const [isPaymentErrorModalVisible, setIsPaymentErrorModalVisible] = useState(false);
  const [currentCardData, setCurrentCardData] = useState({});

  useEffect(() => {
    _getCardData(getCardData, setCardData, setCardDataLoading);
  }, []);
  const theme = useTheme() || LightThemeColors;

  return (
    <ScrollView
      pointerEvents={isCardDataLoading ? 'none' : 'auto'}
      contentContainerStyle={styles.contentContainerStyle(withTray)}
    >
      <View style={styles.wrapper}>
        {!hideScanCard && (
          <ScanCard
            isLoading={isCardDataLoading}
            scanCardDescription={'payment_edit_scan_card_description'}
            {...props}
          />
        )}
        <View style={styles.cardWrapper(theme)}>
          <AddPaymentForm
            {...props}
            contentContainerStyle={{ width: '100%' }}
            onPressSaveCard={cardDataParam =>
              handlePressSaveCard(
                onAsyncActionPressed,
                onPressSaveCard,
                cardDataParam,
                onEditPaymentSuccess,
                setPaymentErrorData,
                setIsPaymentErrorModalVisible,
                setCurrentCardData,
              )
            }
            isCardDataLoading={isCardDataLoading}
            hideSaveCardForLater
            cardData={cardData}
            setModalIsVisible={setIsVisible}
            isEditMood
            savingError={paymentErrorData}
          />
          <DeleteCard
            isVisible={isDeleteCardModalVisible}
            title={cardData.nameOnCard}
            closeModal={() => closeDeleteCardModal(setIsVisible)}
            onPressDeleteCard={() =>
              handlePressDeleteCard(
                onAsyncActionPressed,
                onPressDeleteCard,
                onEditPaymentSuccess,
                setIsVisible,
              )
            }
            images={images}
          />
        </View>
      </View>
      <PaymentError
        isVisible={isPaymentErrorModalVisible}
        currentCardData={currentCardData}
        onPressErrorAction={onPressErrorAction}
        onPressErrorDefaultAction={cardDataParam =>
          handlePressSaveCard(
            onAsyncActionPressed,
            onPressSaveCard,
            cardDataParam,
            onEditPaymentSuccess,
            setPaymentErrorData,
            setIsPaymentErrorModalVisible,
            setCurrentCardData,
          )
        }
        closeModal={() => closePaymentErrorModal(setIsPaymentErrorModalVisible)}
        error={paymentErrorData}
        images={images}
      />
    </ScrollView>
  );
};
EditPayment.defaultProps = {
  getCardData: () => { },
  onEditPaymentSuccess: () => { },
  hideScanCard: true,
  ...ScanCard.defaultProps,
  ...AddPaymentForm.defaultProps,
};
EditPayment.propTypes = {
  hideScanCard: PropTypes.bool,
  getCardData: PropTypes.func,
  onEditPaymentSuccess: PropTypes.func,
  ...ScanCard.proptypes,
  ...AddPaymentForm.proptypes,
  images: PropTypes.object,
};
export default withAsyncAction(EditPayment);
export { _getCardData, formatCardData, handleEditPaymentFailed, closePaymentErrorModal };
